var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("users users-" + (_vm.blur ? 'blur' : '') + " users-" + (!_vm.busy ? 'active' : ''))},[_c('UsersList',{attrs:{"direction":false}}),_vm._v(" "),_c('UserInfo',{attrs:{"person":_vm.person}}),_vm._v(" "),_c('UsersList',{attrs:{"direction":true}}),_vm._v(" "),_c('Share')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cde35370","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Users.vue
// module id = hAdn
// module chunks = 0